<!-- 驳回后   重新修改信息后的提交成功页面 -->
<template>
  <div class="pay-success">
    <img class="icon" src="../../assets/succees.png" /><br />
    <div class="success">修改成功!</div>
    <div class="desc">可到「报考」-「报考信息」中查看审核结果。</div>
    <div >
      <van-row type="flex" gutter="20" class="btn">
        
          <van-col span="12">
			<van-button class="btn_public left" plain type="info" @click="gotoHome()"
            >返回首页</van-button>
		  </van-col>
        
       <van-col span="12">
		<van-button class="btn_public"  type="info" @click="goaudit()"
            >前往查看审核结果</van-button>
	   </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    gotoHome: function () {
      this.$router.push({ path: "/index" });
    },
    goaudit: function () {
      this.$router.push({ path: "/test_info" });
    },
  },
};
</script>
git
<style lang="less" scoped>
.pay-success {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 100px 0;
  .icon {
    width: 160px;
    height: 160px;
  }
  .success {
    font-size: 40px;
  }
  .desc {
    padding: 24px 0 100px 0;
    color: #696969;
  }
  .button {
    padding: 24px 120px;
    border: 1px solid #1989fa;
    border-radius: 8px;
    color: #1989fa;
  }
  .btn {
    width: 750px;
	margin: 30px;
	.btn_public{
		width: 330px;
	}
	.left{
		margin-left: 30px;
	}
  }
}
</style>
